/* plantas finas — Markenband zuweisen

   Warum JavaScript statt reinem CSS: Die Seiten im Shop sind sehr
   unterschiedlich aufgebaut. Der Mondkalender bringt eine eigene Sektion
   (.mk-hero) mit, das Partnerprogramm und Mein Bereich einen .page-hero,
   die Rechtstexte haben gar keinen Einleitungsblock. Ein einzelner
   CSS-Selektor hätte entweder die Hälfte der Seiten verfehlt oder auf
   anderen einen viel zu großen Bereich eingefärbt.

   Diese Datei sucht deshalb pro Seite den passenden Block und vergibt nur
   eine Klasse. Das Aussehen steht vollständig in pf-band.css. */

(function () {
  'use strict';

  /* Die blassen Töne, die bisher im Einsatz waren — als berechnete
     RGB-Werte, weil der Browser Hex-Angaben so zurückgibt.
     #eaf4f1, #f6f8f7, #f5f5f3, #f0f8f5 */
  var DULL = {
    'rgb(234, 244, 241)': 1,
    'rgb(246, 248, 247)': 1,
    'rgb(245, 245, 243)': 1,
    'rgb(240, 248, 245)': 1
  };

  function sectionOf(el, stop) {
    while (el && el !== stop) {
      if (el.tagName === 'SECTION' || (el.classList && el.classList.contains('section'))) return el;
      el = el.parentElement;
    }
    return null;
  }

  function apply() {
    var main = document.getElementById('MainContent');
    if (!main || main.querySelector('.pf-band')) return;

    /* Sicherheitsnetz: Auf Produktseiten wird das Skript gar nicht erst
       geladen (siehe snippets/pf-styles.liquid). Sollte es doch einmal
       dort landen, bricht es hier ab — der knappe Abstand zwischen
       Kopfzeile und Produktbild soll erhalten bleiben. */
    if (main.querySelector('.product__info-container, .product-form__buttons')) return;

    /* 1. Seiten mit eigenem Einleitungsblock */
    var band = main.querySelector('.mk-hero, .page-hero');

    /* 2. Sonst der Block, in dem die erste Vorzeile steht — das ist auf
          den PF-Seiten immer der Einleitungsbereich. */
    if (!band) {
      var eyebrow = main.querySelector('.pf-eyebrow, .section-eyebrow');
      if (eyebrow) band = sectionOf(eyebrow, main);
    }

    if (band) {
      band.classList.add('pf-band');
    } else {
      /* 3. Rechtstexte, Kategorien, Blog und Suche haben keinen solchen
            Block. Dort trägt der Titelbereich das Band, damit auch diese
            Seiten Farbe bekommen. */
      var first = main.querySelector('.shopify-section');
      if (first) {
        first.classList.add('pf-band');
        first.classList.add('pf-band--title');
      }
    }

    /* Weitere graue oder blasse Blöcke auf derselben Seite angleichen,
       damit nicht zwei verschiedene Helltöne nebeneinander stehen. */
    var blocks = main.querySelectorAll('section.section, div.section');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.classList.contains('pf-band') || b.classList.contains('pf-tint')) continue;
      if (DULL[getComputedStyle(b).backgroundColor]) b.classList.add('pf-tint');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
